import React from "react";
import "./SupportedCurrencyPairs.css";

const SupportedCurrencyPairs = () => {
  const currencyPairs = {
    majorPairs: [
      "EUR/USD",
      "GBP/USD",
      "AUD/USD",
      "NZD/USD",
      "EUR/GBP",
      "EUR/CNY",
      "GBP/CNY",
      "EUR/SGD",
      "GBP/SGD",
      "USD/JPY",
      "USD/CNY",
      "USD/CNH",
      "USD/CHF",
      "USD/CAD",
      "USD/HKD",
      "USD/AED",
      "USD/SGD",
      "USD/MYR",
      "USD/INR",
    ],
    crossPairs: [
      "AUD/CAD",
      "AUD/CHF",
      "AUD/JPY",
      "AUD/NZD",
      "CAD/JPY",
      "CHF/JPY",
      "EUR/AUD",
      "EUR/CAD",
      "EUR/CHF",
      "EUR/JPY",
      "EUR/NZD",
      "EUR/PKR",
      "GBP/PKR",
      "AED/PKR",
      "SAR/PKR",
      "CNY/PKR",
      "CNY/CNH",
      "EUR/AED",
      "GBP/AED",
      "PKR/AED",
      "PHP/AED",
      "EUR/SAR",
      "GBP/SAR",
      "PKR/SAR",
      "EUR/LKR",
      "GBP/LKR",
      "AED/LKR",
      "EUR/IDR",
      "GBP/IDR",
      "SGD/IDR",
      "EUR/PHP",
      "GBP/PHP",
      "SGD/PHP",
      "EUR/THB",
      "GBP/THB",
      "EUR/VND",
      "EUR/NGN",
      "GBP/NGN",
      "EUR/KES",
      "GBP/KES",
      "EUR/ZAR",
      "GBP/ZAR",
      "GBP/QAR",
      "EUR/QAR",
      "EUR/OMR",
      "GBP/OMR",
      "EUR/BHD",
      "EUR/BRL",
      "GBP/BRL",
      "EUR/MXN",
      "GBP/MXN",
      "GBP/AUD",
      "GBP/CAD",
      "GBP/CHF",
      "GBP/JPY",
      "GBP/NZD",
      "NZD/CAD",
      "NZD/CHF",
      "NZD/JPY",
    ],
    emergingMarkets: [
      "USD/BRL",
      "USD/MXN",
      "USD/NOK",
      "USD/SEK",
      "USD/THB",
      "USD/ZAR",
      "USD/VND",
      "USD/BGN",
      "USD/COP",
      "USD/PEN",
      "USD/UYU",
      "USD/TWD",
      "USD/EGP",
      "USD/KZT",
      "USD/LKR",
      "USD/MAD",
      "USD/KES",
      "USD/NGN",
      "USD/SAR",
      "USD/QAR",
      "USD/BHD",
      "USD/OMR",
      "USD/PKR",
      "USD/TRY",
      "USD/DKK",
      "USD/PLN",
      "USD/HUF",
      "USD/ILS",
      "USD/IDR",
      "USD/PHP",
      "USD/KRW",
      "USD/RUB",
      "USD/CLP",
      "USD/ARS",
      "USD/KWD",
      "USD/MUR",
      "USD/AZN",
      "USD/GEL",
    ],
    eurPairs: ["EUR/SEK", "EUR/NOK", "EUR/DKK", "EUR/PLN", "EUR/HUF", "EUR/CZK"],
    inrPairs: [
      "GBP/INR",
      "EUR/INR",
      "AUD/INR",
      "NZD/INR",
      "SAR/INR",
      "HKD/INR",
      "ZAR/INR",
      "NOK/INR",
      "SEK/INR",
      "MYR/INR",
      "AED/INR",
      "SGD/INR",
      "CNY/INR",
      "CAD/INR",
      "JPY/INR",
      "CHF/INR",
      "THB/INR",
      "IDR/INR",
      "VND/INR",
      "KRW/INR",
      "LKR/INR",
      "RUB/INR",
      "INR/AED",
    ],
  };

  const categories = [
    {
      title: "Major Currency Pairs",
      pairs: currencyPairs.majorPairs,
      color: "#3b82f6",
    },
    {
      title: "Cross Currency Pairs",
      pairs: currencyPairs.crossPairs,
      color: "#10b981",
    },
    {
      title: "Emerging Market Pairs",
      pairs: currencyPairs.emergingMarkets,
      color: "#f59e0b",
    },
    { title: "EUR Pairs", pairs: currencyPairs.eurPairs, color: "#8b5cf6" },
    { title: "INR Pairs", pairs: currencyPairs.inrPairs, color: "#ef4444" },
  ];

  return (
    <div className="supported-currency-pairs-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-header text-center">
              {/* <h1 className="main-title">Supported Currency Pairs</h1> */}
              <p className="subtitle">
                Comprehensive coverage of major, cross, and emerging market
                currency pairs
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {categories.map((category, index) => (
            <div key={index} className="col-lg-6 col-md-12 mb-5">
              <div className="currency-category">
                <div
                  className="category-header"
                  style={{ borderLeftColor: category.color }}
                >
                  <h3 className="category-title">{category.title}</h3>
                  <span className="pair-count">
                    {category.pairs.length} pairs
                  </span>
                </div>
                <div className="pairs-grid">
                  {category.pairs.map((pair, pairIndex) => (
                    <div key={pairIndex} className="currency-pair">
                      <span className="pair-code">{pair}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row">
          <div className="col-12">
            <div className="summary-section">
              <div className="summary-card">
                <h4>Total Supported Pairs</h4>
                <div className="total-count">3000+ pairs on demand</div>
                <p>Comprehensive coverage for all your forex trading needs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportedCurrencyPairs;
